const BASE_PATHS = {
  USER: "/user",
  QUESTION: "/question",
  MODULE: "/module/",
  CLASS: "/class",
  PRACTICE_TEST: "/practice-test",
  ATTEMPT: "/attempt",
  MARK: "/mark",
};

export const ENDPOINTS = {
  SIGN_IN: `${BASE_PATHS.USER}/login`,
  GET_QUESTIONS_BY_MODULE: `${BASE_PATHS.QUESTION}/module`,
  GET_MODULES: `${BASE_PATHS.MODULE}`,
  GET_CLASS_BY_MODULE: `${BASE_PATHS.CLASS}/with-counts`,
  INIT_ATTEMPT: `${BASE_PATHS.ATTEMPT}/init`,
  UPDATE_ATTEMPT: `${BASE_PATHS.ATTEMPT}/update`,
  GET_CONFIG: `${BASE_PATHS.MODULE}config/`,
  GET_ME: `${BASE_PATHS.USER}/me`,
  REFRESH_TOKEN: `${BASE_PATHS.USER}/refresh`,
  CREATE_PRACTICE_TEST: `${BASE_PATHS.PRACTICE_TEST}/create-practice-test`,
  DUPLICATE_PRACTICE_TEST: `${BASE_PATHS.PRACTICE_TEST}/duplicate`,
  FEEDBACK: `${BASE_PATHS.MARK}/feedback`,
  REGISTER: `${BASE_PATHS.USER}/register-manual`,
  REQUEST_RESET_PASSWORD: `${BASE_PATHS.USER}/auth/request-reset`,
  RESET_PASSWORD: `${BASE_PATHS.USER}/auth/reset-password`,
  CHANGE_EMAIL_PASSWORD: `${BASE_PATHS.USER}/change-email-and-password`,
  UPDATE_PRACTICE_TEST: (ptId?: number) =>
    `${BASE_PATHS.PRACTICE_TEST}/update/${ptId}`,
  DELETE_PRACTICE_TEST: (ptId?: number) =>
    `${BASE_PATHS.PRACTICE_TEST}/${ptId}`,
  PUBLISH_PRACTICE_TEST: (ptId?: number) =>
    `${BASE_PATHS.PRACTICE_TEST}/${ptId}/publish`,
  GET_QUESTIONS_BY_ID: (id: number) => `${BASE_PATHS.QUESTION}/${id}`,
  GET_CLASS_BY_ID: (classId: number) => `${BASE_PATHS.CLASS}/${classId}`,
  GET_ALL_EXAMS_BY_CLASS_ID: (classId: number) =>
    `${BASE_PATHS.PRACTICE_TEST}/${classId}/students`,
  GET_EXAM_READ_TIME: (practiceTestId?: number, studentId?: number) =>
    `${BASE_PATHS.ATTEMPT}/${practiceTestId}/${studentId}/read`,
  START_READ_EXAM: (practiceTestId?: number, studentId?: number) =>
    `${BASE_PATHS.ATTEMPT}/${practiceTestId}/${studentId}/start-read`,
  GET_ATTEMPT_DETAIL: (practiceTestId?: number, studentId?: number) =>
    `${BASE_PATHS.ATTEMPT}/${practiceTestId}/${studentId}/checkpoint`,
  GET_ATTEMPT_SHEET: (className: string, testName: string, fullName: string) =>
    `${BASE_PATHS.ATTEMPT}/auth/get_sheetlink?class_name=${className}&test_name=${testName}&full_name=${fullName}`,

  GET_CLASS_STATISTICS: (classId: number) =>
    `${BASE_PATHS.CLASS}/${classId}/statistics`,
  GET_SECTIONS_BY_MODULE: (moduleId?: number) =>
    `${BASE_PATHS.MODULE}sections/${moduleId}`,
  GET_MY_EXAMS_BY_CLASS_ID: (classId?: number) =>
    `${BASE_PATHS.PRACTICE_TEST}/${classId}/my-pts`,
  GET_RANDOM_PT_QUESTION_LIST: (classId?: number) =>
    `${BASE_PATHS.PRACTICE_TEST}/${classId}/random-pt-question-list`,
  CREATE_RANDOM_PRACTICE_TEST: `${BASE_PATHS.PRACTICE_TEST}/create-random-practice-test`,
  GET_RANDOM_PRACTICE_TEST: (ptId: number) =>
    `${BASE_PATHS.PRACTICE_TEST}/${ptId}/detail-random-pt`,
  GET_STATUS_PRACTICE_TEST: (ptId: number) =>
    `${BASE_PATHS.PRACTICE_TEST}/${ptId}/status`,
  GET_LIST_CLASS_TUTORS: (muduleId: number | null) =>
    `${BASE_PATHS.CLASS}/tutors${muduleId ? `?module_id=${muduleId}` : ""}`,
  GET_LIST_CLASS_YEARS: (muduleId: number | null) =>
    `${BASE_PATHS.CLASS}/years${muduleId ? `?module_id=${muduleId}` : ""}`,
  EXCHANGE_TOKEN: `${BASE_PATHS.USER}/auth/exchange`,
};
